module.exports = __webpack_public_path__ + "static/img/youxiu_logo_wenzi@2x.cca5f3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/youxiu_logo_wenzi@2x.png
// module id = 271
// module chunks = 1